
import { devotionsData } from '../../../mocks/devotions';

const DevotionsSection = () => {
  return (
    <section id="devotions" className="py-20 px-6 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-serif font-bold text-[#1B3A52] mb-12">
          Recent Reflections
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {devotionsData.map((devotion) => (
            <div
              key={devotion.id}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <p className="text-xs text-[#D4AF37] font-semibold uppercase tracking-wider mb-4">
                {devotion.date}
              </p>
              <h3 className="text-lg font-serif font-bold text-[#1B3A52] mb-4 leading-tight">
                {devotion.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6 line-clamp-3">
                {devotion.excerpt}
              </p>
              <a href="#" className="text-[#1B3A52] text-sm font-medium hover:text-[#D4AF37] transition-colors inline-flex items-center gap-2">
                Read More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevotionsSection;
